import Default from "../Pages/Dashboard/Default/Default";
import BookTicket from "../Pages/Application/Master/book_ticket/BookTicket";
import BookingHistory from "../Pages/Application/Master/book_ticket/BookingHistory";
import BookingCancelled from "../Pages/Application/Master/book_ticket/BookingCancelled";
import AccountProfile from "../Pages/SamplePage/AccountProfile";
import AccountSettings from "../Pages/SamplePage/AccountSettings";
import BookingInvoice from "../Pages/Application/Master/book_ticket/BookingInvoice";
import BookingHistoryReport from "../Pages/SamplePage/BookingHistoryReport";
import CardAssign from "../Pages/Cardasign/CardAssign";
import AllCardAssign from "../Pages/Application/Master/book_ticket/AllCardAssign";
import RechargeAmountGrid from "../Pages/SamplePage/RechargeAmountGrid";
import RechargeHistory from "../Pages/Application/Master/book_ticket/RechargeHistory";


const ticketCRoutes = [
  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },
 // Account
   { path: `${process.env.PUBLIC_URL}/account/account_settings`, Component: <AccountSettings /> },
   { path: `${process.env.PUBLIC_URL}/account/account_profile`, Component: <AccountProfile /> },
 
   // Ticket Booking
   { path: `${process.env.PUBLIC_URL}/ticket/book_ticket`, Component: <BookTicket /> },
   { path: `${process.env.PUBLIC_URL}/ticket/booking_history`, Component: <BookingHistory /> },
   { path: `${process.env.PUBLIC_URL}/ticket/booking_cancelled`, Component: <BookingCancelled /> },
   { path: `${process.env.PUBLIC_URL}/ticket-booking-invoice/:id`, Component: <BookingInvoice /> },
   { path: `${process.env.PUBLIC_URL}/report/booking-history-report/:staffid`, Component: <BookingHistoryReport /> },
  //  { path: `${process.env.PUBLIC_URL}/card/card_assign`, Component: <CardAssign/> },
  //  { path: `${process.env.PUBLIC_URL}/card/all_card_assign`, Component: <AllCardAssign/> },
  //  { path: `${process.env.PUBLIC_URL}/recharge/card_recharge`, Component: <RechargeAmountGrid /> },
  // { path: `${process.env.PUBLIC_URL}/recharge/recharge_history`, Component: <RechargeHistory /> },
];

export default ticketCRoutes;
